import React from 'react';
import { useQuery } from '@apollo/client';
import { FlatIcon } from '../../../atoms/Icons/FlatIcon';
import FormatDisplayDate from '../../../atoms/DisplayDate/FormatDisplayDate';
import useStyle from './FeatureClasseInfos.style';
import { QUERY_CLASSE_INFO } from '../../../../graphql/query/classe/queryClasseInfos';
import { GetCurrentClasseInfoQuery } from '../../../../graphql/generated/graphql';
export const FeatureClasseInfos = () => {
  const classes = useStyle();
  const { data, loading, error } = useQuery<GetCurrentClasseInfoQuery>(
    QUERY_CLASSE_INFO
  );
  if (loading) return <p>Loading</p>;
  if (error) return <p>error</p>;

  const maClasse = data?.getCurrentClasseInfos;
  return (
    <div className={classes.root}>
      <h3 className={classes.title}>
        {maClasse?.name} - {maClasse.niveau} - {maClasse.filiere}
      </h3>
      <div className={classes.infosContainer}>
        <div className={classes.textIconContainer}>
          <FlatIcon color={'#959595'} icon={'Users'} />
          <p>
            {maClasse?.nbEleves} élèves et {maClasse?.nbProfs}
            {maClasse?.nbProfs > 1 ? ' profs ' : ' prof '}
            <span role="img" aria-label="professeur">
              🧑‍🏫
            </span>
          </p>
        </div>
        <div className={classes.textIconContainer}>
          <FlatIcon color={'#959595'} icon={'Calendar'} />
          <p>
            Du <FormatDisplayDate date={maClasse?.debut} /> au{' '}
            <FormatDisplayDate date={maClasse?.fin} />
          </p>
        </div>
      </div>
    </div>
  );
};
